/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */
import { FileExtension } from './file-extension.model';
import { FileType } from './file-type.model';

export interface FileData {
  blob?: Blob;
  b64?: string;
  name?: string;
  extension?: FileExtension;
  savingName?: string;
  type?: FileType;
}
